import { computed, defineComponent, useCssModule, useRouter } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxGallery',
    inheritAttrs: false,
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        const css = useCssModule();
        const router = useRouter();
        const gallery = computed(() => {
            const { data } = props.box;
            if (!data) {
                return console.error('[BoxGallery] There is no data in box');
            }
            if (data.article) {
                return data.article;
            }
            if (!Array.isArray(data)) {
                return console.error('[BoxGallery] data is not an array');
            }
            return {
                gallery: data.reduce((items, item) => {
                    const { author = '', caption = [], file = {}, source = '', subtitle = '', title = '' } = item || {};
                    if (!file || toString.call(file) !== '[object Object]') {
                        return items;
                    }
                    items.push({
                        ...file,
                        author,
                        caption,
                        source,
                        subtitle,
                        title,
                    });
                    return items;
                }, []),
            };
        });
        function handleClick() {
            const { url_alias: url } = gallery.value || {};
            if (!url) {
                return console.error('[BoxGallery] There is no url_alias in gallery');
            }
            router.push(`/${url}`);
        }
        return {
            css,
            gallery,
            handleClick,
        };
    },
});
